class MainSearch extends SearchForm {
  constructor() {
    super();
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

customElements.define('main-search', MainSearch);
